import moment from "moment";
import { appConfig } from "../../configs";
import {
  IViewBankTransferBeneficiary,
  IViewGatewayTransferBeneficiary,
} from "../../interfaces-and-types";
import { CopyButton } from "../../components";

export const beneficiariesDisplayFormatter = (
  item: IViewBankTransferBeneficiary & IViewGatewayTransferBeneficiary
) => {
  return {
    ...item,
    email: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.email}>{item.email}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            // name="copy-beneficiary-email-button"
            stringToCopy={item.email}
            iconDescription="copy beneficiary email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    bank_name: item.gateway_name,
    account_name: (
      <strong>
        {(item.account_name ?? item.merchant_name)?.toUpperCase()}
      </strong>
    ),
    account_number: (
      <strong>{item.account_number ?? item.merchant_id_or_code}</strong>
    ),
    full_name: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.full_name}>{item.full_name || "(anonymous)"}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            // name="copy-beneficiary-alias-button"
            stringToCopy={item.full_name || ""}
            iconDescription="copy beneficiary alias"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    phone_number: !item.phone_number ? (
      "..."
    ) : (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.phone_number}>{item.phone_number}</span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            stringToCopy={item.phone_number}
            iconDescription="copy customer email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    // more: <OverflowMenuVertical />,
  };
};
